export default "__VITE_ASSET__fc46cb0e__"